import { createReducer } from '@reduxjs/toolkit';
import { TrainingsListState } from '../types';
import { fetchTrainings } from './actions';

const initialState: TrainingsListState = {
  loading: true,
  response: undefined,
};

export const trainingsListReducer = createReducer<TrainingsListState>(initialState, builder => {
  builder
    .addCase(fetchTrainings.processing, state => {
      state.loading = true;
    })
    .addCase(fetchTrainings.success, (state, action) => {
      state.loading = false;
      state.response = action.payload;
    })
    .addCase(fetchTrainings.failed, state => {
      state.loading = false;
    });
});
